
import React from 'react';
import { Button } from '@/components/ui/button';

interface InterviewDialogActionsProps {
  onClose: () => void;
  onOpenPublishConfirm: () => void;
  onOpenFeederConfirm: () => void;
  isInFeeder: boolean;
  isPublishing: boolean;
  isSendingToFeeder: boolean;
  isDisabled: boolean;
  interview?: any; // Adding this prop to fix type error
}

const InterviewDialogActions: React.FC<InterviewDialogActionsProps> = ({
  onClose,
  onOpenPublishConfirm,
  onOpenFeederConfirm,
  isInFeeder,
  isPublishing,
  isSendingToFeeder,
  isDisabled,
  interview // Add this to component props
}) => {
  return (
    <div className="mt-6 space-x-2">
      <Button variant="outline" onClick={onClose}>
        Lukk
      </Button>
      
      {!isInFeeder && (
        <Button 
          variant="outline"
          className={`${isSendingToFeeder ? 'bg-blue-50' : ''} text-blue-600 hover:text-blue-700 hover:bg-blue-50`}
          onClick={onOpenFeederConfirm}
          disabled={isDisabled}
        >
          {isSendingToFeeder ? 'Sender til køen...' : 'Send til køen'}
        </Button>
      )}
      
      <Button 
        onClick={onOpenPublishConfirm}
        disabled={isDisabled}
      >
        {isPublishing ? 'Publiserer...' : 'Publiser'}
      </Button>
    </div>
  );
};

export default InterviewDialogActions;
